export function equalsIgnoringCase(s1: string, s2: string) {
    return s1.localeCompare(s2, undefined, { sensitivity: 'base' }) === 0;
}